import { Icon, ICONS, colors, TooltipPosition } from '@creditsights/styleguide-web';

import React, { ReactElement, useState } from 'react';
import { MY_CONTENT_ROUTES, ROUTES } from '../../../../Base.constants';
import { ContextMenu, ContextMenuItem } from '../../../../components/ContextMenu';

const PersonalizeMyCSButton = (): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ContextMenu
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      tooltip="Configure your preferences and watchlists to personalize your feed"
      triggerIcon={<Icon name={ICONS.Gear} color={colors.primary800} />}
      dataTestId="personalize-my-cs-trigger"
      bigger
      position={TooltipPosition.BottomLeft}
    >
      <ContextMenuItem
        small
        title="Preferences"
        linkTo={`${ROUTES.myContent}/${MY_CONTENT_ROUTES.managePreferences}`}
      />
      <ContextMenuItem small title="Watchlists" linkTo={`${ROUTES.myContent}/${MY_CONTENT_ROUTES.watchlists()}`} />
    </ContextMenu>
  );
};

export default PersonalizeMyCSButton;
